import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as fromCalculator from './reducers/calculator.reducer';
import * as fromChart from './reducers/chart.reducer';
import * as fromConfig from './reducers/config.reducer';
import * as fromDataPortal from './reducers/data-portal.reducer';
import * as fromDataProvider from './reducers/data-provider.reducer';
import * as fromDevice from './reducers/device.reducer';
import * as fromLayout from './reducers/layout.reducer';
import * as fromMap from './reducers/map.reducer';
import * as fromMonetization from './reducers/monetization.reducer';
import * as fromNetSheet from './reducers/net-sheet.reducer';
import * as fromOffice from './reducers/office.reducer';
import * as fromOrganization from './reducers/organization.reducer';
import * as fromPropertyProfile from './reducers/property-profile.reducer';
import * as fromPushNotifications from './reducers/push-notifications.reducer';
import * as fromSetting from './reducers/setting.reducer';
import * as fromTitleRep from './reducers/title-rep.reducer';
import * as fromUser from './reducers/user.reducer';
import * as fromWalkingFarm from './reducers/walking-farm.reducer';
import * as fromTheme from './reducers/white-labeling.reducer';

export interface SmdState {
  [fromCalculator.calculatorFeatureKey]: fromCalculator.State;
  [fromChart.chartFeatureKey]: fromChart.State;
  [fromConfig.configFeatureKey]: fromConfig.State;
  [fromDataPortal.dataPortalFeatureKey]: fromDataPortal.State;
  [fromDataProvider.dataProviderFeatureKey]: fromDataProvider.State;
  [fromDevice.deviceFeatureKey]: fromDevice.State;
  [fromLayout.layoutFeatureKey]: fromLayout.State;
  [fromMap.mapFeatureKey]: fromMap.State;
  [fromMonetization.monetizationFeatureKey]: fromMonetization.State;
  [fromNetSheet.netSheetFeatureKey]: fromNetSheet.State;
  [fromOffice.officeFeatureKey]: fromOffice.State;
  [fromOrganization.organizationFeatureKey]: fromOrganization.State;
  [fromPropertyProfile.propertyProfileFeatureKey]: fromPropertyProfile.State;
  [fromPushNotifications.pushNotificationsFeatureKey]: fromPushNotifications.State;
  [fromSetting.settingFeatureKey]: fromSetting.State;
  [fromTheme.whiteLabelingFeatureKey]: fromTheme.State;
  [fromTitleRep.titleRepFeatureKey]: fromTitleRep.State;
  [fromUser.userFeatureKey]: fromUser.State;
  [fromWalkingFarm.walkingFarmFeatureKey]: fromWalkingFarm.State;
}

export const reducers: ActionReducerMap<SmdState> = {
  [fromCalculator.calculatorFeatureKey]: fromCalculator.reducer,
  [fromChart.chartFeatureKey]: fromChart.reducer,
  [fromConfig.configFeatureKey]: fromConfig.reducer,
  [fromDataPortal.dataPortalFeatureKey]: fromDataPortal.reducer,
  [fromDataProvider.dataProviderFeatureKey]: fromDataProvider.reducer,
  [fromDevice.deviceFeatureKey]: fromDevice.reducer,
  [fromLayout.layoutFeatureKey]: fromLayout.reducer,
  [fromMap.mapFeatureKey]: fromMap.reducer,
  [fromMonetization.monetizationFeatureKey]: fromMonetization.reducer,
  [fromNetSheet.netSheetFeatureKey]: fromNetSheet.reducer,
  [fromOffice.officeFeatureKey]: fromOffice.reducer,
  [fromOrganization.organizationFeatureKey]: fromOrganization.reducer,
  [fromPropertyProfile.propertyProfileFeatureKey]: fromPropertyProfile.reducer,
  [fromPushNotifications.pushNotificationsFeatureKey]: fromPushNotifications.reducer,
  [fromSetting.settingFeatureKey]: fromSetting.reducer,
  [fromTheme.whiteLabelingFeatureKey]: fromTheme.reducer,
  [fromTitleRep.titleRepFeatureKey]: fromTitleRep.reducer,
  [fromUser.userFeatureKey]: fromUser.reducer,
  [fromWalkingFarm.walkingFarmFeatureKey]: fromWalkingFarm.reducer
};

export const metaReducers: MetaReducer<SmdState>[] = [];
